import { ILocationProvider } from 'angular';
import { StateProvider, UrlService } from '@uirouter/angularjs';
import { states } from 'states';
import { CurrentUserService } from 'services/currentUser';

// tslint:disable-next-line:no-big-function
export default function UIRouterConfig(
    $stateProvider: StateProvider,
    $urlServiceProvider: UrlService,
    $locationProvider: ILocationProvider
) {
    'ngInject';

    $stateProvider.state({
        name: 'error',
        url: '/error',
        template: states.error.template,
        controller: states.error.controller,
        resolve: states.error.resolve,
        onEnter: states.error.onEnter,
        onExit: states.error.onExit
    });

    $stateProvider.state({
        name: 'login',
        url: '/login',
        template: states.login.template,
        controller: states.login.controller,
        resolve: states.login.resolve,
        onEnter: states.login.onEnter,
        onExit: states.login.onExit
    });

    $stateProvider.state({
        name: 'login-remember',
        url: '/login/remember',
        template: states.login.template,
        controller: states.login.controller,
        resolve: states.login.resolve,
        onEnter: states.login.onEnter,
        onExit: states.login.onExit
    });

    $stateProvider.state({
        name: 'logout',
        url: '/logout',
        template: states.logout.template,
        controller: states.logout.controller,
        resolve: states.logout.resolve,
        onEnter: states.logout.onEnter,
        onExit: states.logout.onExit
    });

    $stateProvider.state({
        name: 'policies',
        url: '/policies',
        template: states.policies.template,
        controller: states.policies.controller,
        resolve: states.policies.resolve
    });

    $stateProvider.state({
        name: 'overview',
        url: '/policy/:policyIndex/overview',
        template: states.overview.template,
        controller: states.overview.controller,
        resolve: states.overview.resolve
    });

    $stateProvider.state({
        name: 'coverage',
        url: '/policy/:policyIndex/coverage',
        template: states.coverage.template,
        controller: states.coverage.controller,
        resolve: states.coverage.resolve
    });

    $stateProvider.state({
        name: 'checklist',
        url: '/policy/:policyIndex/checklist',
        template: states.checklist.template,
        controller: states.checklist.controller,
        resolve: states.checklist.resolve
    });

    $stateProvider.state({
        name: 'payments',
        url: '/policy/:policyIndex/payments',
        controller: function(
            $window: angular.IWindowService,
            $stateParams: PolicyStateParams,
            currentUserService: CurrentUserService
        ) {
            currentUserService.getCustomerPolicyInfoByIndex($stateParams.policyIndex).then((policy) => {
                $window.location.href = policy
                    ? `${window.appConfig.REACT_HOST}/policy/${policy.policy_uuid}/payments`
                    : `/policy/${$stateParams.policyIndex}/overview`;
            });
        }
    });

    $stateProvider.state({
        name: 'messages',
        url: '/policy/:policyIndex/messages',
        template: states.messages.template,
        controller: states.messages.controller,
        resolve: states.messages.resolve
    });

    $stateProvider.state({
        name: 'get-more',
        url: '/policy/:policyIndex/get-more',
        template: states.getMore.template,
        controller: states.getMore.controller,
        resolve: states.getMore.resolve
    });

    $stateProvider.state({
        name: 'policy-claims',
        url: '/policy/:policyIndex/claims',
        template: states.claims.template,
        controller: states.claims.controller,
        resolve: states.claims.resolve
    });

    $stateProvider.state({
        name: 'claims',
        url: '/claims',
        template: states.claims.template,
        controller: states.claims.controller,
        resolve: states.claims.resolve
    });

    $stateProvider.state({
        name: 'policy-by-number',
        url: '/policy-by-number/:policyNumber/{path:[a-zA-Z0-9-/]*}?',
        controller: function(
            $window: angular.IWindowService,
            $stateParams: PolicyByNumberStateParams,
            currentUserService: CurrentUserService
        ) {
            currentUserService.getDisplayOrderedCustomerPolicyInfos(false).then(() => {
                const policyIndex = currentUserService.getPolicyNumberToPolicyIndexMap()[
                    $stateParams.policyNumber.toLowerCase()
                ];
                $window.location.href = policyIndex
                    ? `policy/${policyIndex}/${$stateParams.path}${$window.location.search}`
                    : 'policies';
            });
        }
    });

    $stateProvider.state({
        name: 'policy-by-uuid',
        url: '/policy-by-uuid/:policyUUID/{path:[a-zA-Z0-9-/]*}?',
        controller: function(
            $window: angular.IWindowService,
            $stateParams: PolicyByUUIDStateParams,
            currentUserService: CurrentUserService
        ) {
            currentUserService.getDisplayOrderedCustomerPolicyInfos(false).then(() => {
                const policyIndex = currentUserService.getPolicyUUIDToPolicyIndexMap()[$stateParams.policyUUID];
                $window.location.href = policyIndex
                    ? `policy/${policyIndex}/${$stateParams.path}${$window.location.search}`
                    : 'policies';
            });
        }
    });

    $stateProvider.state({
        name: 'smart-home',
        url: '/policy/:policyIndex/smart-home',
        controller: function(
            $window: angular.IWindowService,
            $stateParams: PolicyStateParams,
            currentUserService: CurrentUserService
        ) {
            currentUserService.getCustomerPolicyInfoByIndex($stateParams.policyIndex).then((policy) => {
                $window.location.href = policy
                    ? `${window.appConfig.REACT_HOST}/policy/${policy.policy_uuid}/smart-home`
                    : `/policy/${$stateParams.policyIndex}/overview`;
            });
        }
    });

    $urlServiceProvider.rules.otherwise('login');
    $locationProvider.html5Mode(true);
}
